import { createContext } from "react";

import { FactorData, Factor } from "types/factor/factor";

type RemoveFactorContextType = {
  isRemoveEnabled: boolean;
  setFactorData: (factorData: FactorData | undefined) => void;
  openRemoveModal: (factor: Factor) => void;
};

const RemoveFactorContext = createContext<RemoveFactorContextType>({
  isRemoveEnabled: false,
  setFactorData: () => undefined,
  openRemoveModal: () => undefined,
});

export default RemoveFactorContext;
